import UserPreferencesWorkspace from "@/UserPreferencesWorkspace"; // Note: Absolute path import

import RouteLayout, { RouteErrorLayout } from "components/Menu/components/RouteLayout";
import ChangeAuditReport from "components/System/ChangeAuditReport";

import AgencyEditWorkspace from "../components/System/AgencyEditWorkspace";
import AgencyListWorkspace from "../components/System/AgencyListWorkspace";
import AipPassServerWorkspace from "../components/System/AipPassServerWorkspace";
import AipPassVendorListWorkspace from "../components/System/AipPassVendorListWorkspace";

export const systemRoutes = [
  {
    path: "/system/change_audit/",
    element: <RouteLayout />,
    children: [{ index: true, element: <ChangeAuditReport /> }],
    errorElement: <RouteErrorLayout errorTitle="Change Audit" />,
  },
  {
    path: "/system/agencies/",
    element: <RouteLayout />,
    children: [{ index: true, element: <AgencyListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Agencies" />,
  },
  {
    path: "/system/agencies/:agency_id",
    element: <RouteLayout />,
    children: [{ index: true, element: <AgencyEditWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="Agencies" />,
  },
  {
    path: "/system/aip-pass",
    element: <RouteLayout />,
    children: [{ index: true, element: <AipPassVendorListWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="AIP PASS" />,
  },
  {
    path: "/system/aip-pass/:vendor",
    element: <RouteLayout />,
    children: [{ index: true, element: <AipPassServerWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="AIP PASS" />,
  },
  {
    path: "/change-totp",
    element: <RouteLayout />,
    children: [{ index: true, element: <UserPreferencesWorkspace /> }],
    errorElement: <RouteErrorLayout errorTitle="User Preferences" />,
  },
];
